import TypesList from 'modules/Recommendations/CampaignsRecommendations/TypesList/TypesList'
import Reducer from 'modules/Recommendations/CampaignsRecommendations/TypesList/store/reducer'
import Sagas from 'modules/Recommendations/CampaignsRecommendations/TypesList/store/saga'

export default TypesList

export { Sagas, Reducer }
